// import defaultRSVP from "../../images/rsvp/defaultRSVP.jpg";
import defaultRSVP from "../../images/hero/home-1.jpg";

import RSVPFrom from "../RSVPFrom/RSVPFrom";
import { connect } from "react-redux";
import { Slide } from "react-awesome-reveal";
import AutoMuteVideo from "../AutoMuteVideo/AutoMuteVideo";
import {
  getCloudinaryFullPath,
  getCloudinaryFullPathVideo,
  isRsvpEnabled,
} from "../../utils";

const RsvpSectionS2 = ({
  rClass,
  rsvpConfigs,
  rsvpVideo,
  rsvpPhoto,
  events,
}) => {
  if (!isRsvpEnabled(rsvpConfigs)) return null;

  return (
    <section
      className={`wpo-contact-section-s3 section-padding ${rClass}`}
      id="rsvp"
    >
      <div className="container">
        <div
          className="row align-items-center"
          style={{ justifyContent: "center" }}
        >
          <div className="col col-xl-5 col-lg-5 col-md-12 col-12">
            <Slide direction="left" duration={1000} triggerOnce="true">
              <div className="wpo-contact-section-wrapper">
                <div className="wpo-contact-form-area">
                  <div className="wpo-section-title">
                    <h2>Your gracious presence is sincerely requested</h2>
                  </div>
                  <RSVPFrom rsvpConfigs={rsvpConfigs} events={events} />
                </div>
              </div>
            </Slide>
          </div>
          <Slide
            className="col-xl-5 col-lg-5 col-md-12 col-12"
            direction="right"
            duration="2000"
            triggerOnce="true"
          >
            <div className="col contact-img">
              {rsvpVideo ? (
                <AutoMuteVideo src={getCloudinaryFullPathVideo(rsvpVideo)} />
              ) : (
                rsvpPhoto ? <img
                  src={getCloudinaryFullPath(rsvpPhoto)}
                  alt=""
                /> : null
              )}
            </div>
            {/* )} */}
          </Slide>
        </div>
      </div>
    </section>
  );
};

const mapStateToProps = (state) => {
  return {
    rsvpPhoto: state.inviteDetails.invite?.rsvpPhoto,
    rsvpConfigs: state.inviteDetails.invite?.rsvpConfigs,
    rsvpVideo: state.inviteDetails.invite?.rsvpVideo,
    pathname: state.inviteDetails.invite?.pathname,
    events: state.inviteDetails.invite?.events,
  };
};

export default connect(mapStateToProps)(RsvpSectionS2);
